(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cb-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-cb-carousel]';

    const slidesOf = (track) => Array.from(track.children);

    /* Index of whichever slide is nearest the track's horizontal centre. */
    const currentIndex = (track) => {
      const slides = slidesOf(track);
      if (!slides.length) return 0;
      const midpoint = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDistance = Infinity;
      slides.forEach((slide, index) => {
        const centre = slide.offsetLeft - track.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(centre - midpoint);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = index;
        }
      });
      return best;
    };

    const scrollToIndex = (track, index) => {
      const slides = slidesOf(track);
      if (!slides.length) return;
      const clamped = Math.max(0, Math.min(index, slides.length - 1));
      const target = slides[clamped];
      if (!target) return;
      track.scrollTo({
        left: target.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    };

    const init = (root) => {
      const track = root.querySelector('[data-cb-carousel-track]');
      /* Declining rather than failing: a root whose track has not rendered yet
         must be offered again, not written off. See cb-enhance. */
      if (!track) return false;

      const previous = root.querySelector('[data-cb-carousel-prev]');
      const next = root.querySelector('[data-cb-carousel-next]');
      const dotsHost = root.querySelector('[data-cb-carousel-dots]');
      const slides = slidesOf(track);
      const dots = [];

      if (dotsHost && slides.length > 1) {
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cb-carousel__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
          dot.addEventListener('click', () => scrollToIndex(track, index));
          dotsHost.appendChild(dot);
          dots.push(dot);
        });
      }

      const sync = () => {
        const index = currentIndex(track);
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        /* Sub-pixel scroll widths mean these never land exactly on 0 or scrollWidth. */
        if (previous) previous.disabled = track.scrollLeft <= 1;
        if (next) {
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        }
      };

      if (previous) {
        previous.addEventListener('click', () => scrollToIndex(track, currentIndex(track) - 1));
      }
      if (next) {
        next.addEventListener('click', () => scrollToIndex(track, currentIndex(track) + 1));
      }

      let frame = null;
      track.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = requestAnimationFrame(() => {
            frame = null;
            sync();
          });
        },
        { passive: true }
      );

      root.classList.add('cb-carousel--enhanced');
      sync();
    };

    (window.cbEnhancements = window.cbEnhancements || []).push({
      selector: ROOT_SELECTOR,
      init: init,
    });

    /* The one editor event that is this block's alone: scroll a selected child
       into view, so the editor's selection is actually visible. Section reloads
       are cb-enhance's job; this only makes sure the root is enhanced before
       scrolling it, in case the selection arrives first. */
    document.addEventListener('shopify:block:select', (event) => {
      const target = event.target;
      if (!target || !target.closest) return;
      const root = target.closest(ROOT_SELECTOR);
      if (!root) return;
      if (window.cbEnhancements && window.cbEnhancements.refresh) {
        window.cbEnhancements.refresh();
      }
      const track = root.querySelector('[data-cb-carousel-track]');
      if (!track) return;
      const slide = slidesOf(track).find((child) => child === target || child.contains(target));
      if (slide) scrollToIndex(track, slidesOf(track).indexOf(slide));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-cb-countdown]';

    const pad = (value) => String(value).padStart(2, '0');

    const renderUnits = (root, remaining) => {
      const units = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60,
      };
      Object.keys(units).forEach((name) => {
        const cell = root.querySelector('[data-cb-countdown-unit="' + name + '"]');
        if (cell) cell.textContent = pad(units[name]);
      });
    };

    const expire = (root) => {
      root.classList.add('cb-countdown--expired');
      if (root.dataset.cbCountdownOnExpiry === 'hide') {
        root.hidden = true;
        return;
      }
      const timer = root.querySelector('[data-cb-countdown-timer]');
      if (timer) timer.hidden = true;
      const message = root.querySelector('[data-cb-countdown-message]');
      if (message) message.hidden = false;
    };

    const init = (root) => {
      const deadline = Number(root.dataset.cbCountdownDeadline);
      /* Declining, not failing: an expired or unset countdown withholds the
         attribute on purpose, and must stay eligible if one ever arrives.
         See cb-enhance. */
      if (!Number.isFinite(deadline) || deadline <= 0) return false;

      let interval = null;
      const tick = () => {
        /* A theme-editor section reload replaces the node; without this the old
           interval keeps ticking against a detached element forever. */
        if (!root.isConnected) {
          clearInterval(interval);
          return;
        }
        const remaining = Math.floor(deadline - Date.now() / 1000);
        if (remaining <= 0) {
          renderUnits(root, 0);
          clearInterval(interval);
          expire(root);
          return;
        }
        renderUnits(root, remaining);
      };

      interval = setInterval(tick, 1000);
      tick();
    };

    (window.cbEnhancements = window.cbEnhancements || []).push({
      selector: ROOT_SELECTOR,
      init: init,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-enhance"] && !Shopify.designMode) return;
  try {
    (() => {
    const registry = (window.cbEnhancements = window.cbEnhancements || []);
    /* Rendered by three snippets, so this runs once per page and must be
       idempotent — a second install would re-wrap push and double-run. */
    if (registry.cbInstalled) return;
    registry.cbInstalled = true;

    /* One WeakSet per registration, keyed by the element. A data- attribute
       would work too, but it survives in the DOM as noise and needs a unique
       name per block; this needs neither and lets a reloaded section's fresh
       elements be enhanced without clearing anything. */
    const enhanced = new WeakMap();

    const seenBy = (entry) => {
      if (!enhanced.has(entry)) enhanced.set(entry, new WeakSet());
      return enhanced.get(entry);
    };

    const run = (entry) => {
      if (!entry || !entry.selector || typeof entry.init !== 'function') return;
      const seen = seenBy(entry);
      document.querySelectorAll(entry.selector).forEach((root) => {
        if (seen.has(root)) return;
        try {
          /* Marked only on acceptance, so a decline is retried next pass. */
          if (entry.init(root) !== false) seen.add(root);
        } catch (error) {
          /* Contained, but never swallowed: a silent failure here is a control
             that renders and does nothing, which is worse than a loud one. */
          seen.add(root);
          console.error('[content blocks] enhancement failed for ' + entry.selector, error);
        }
      });
    };

    const runAll = () => registry.forEach(run);

    /* A block parsed AFTER this file would otherwise sit in the array unread. */
    registry.push = function (entry) {
      Array.prototype.push.call(this, entry);
      if (document.readyState !== 'loading') run(entry);
      return this.length;
    };

    registry.refresh = runAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runAll);
    } else {
      runAll();
    }

    /* Theme editor: a reloaded section brings elements nothing has enhanced. */
    document.addEventListener('shopify:section:load', runAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-offer-callout"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-cb-offer]';
    /* Long enough to read the confirmation, short enough that the button is
       back to its real label before anyone reaches for it again. */
    const RESET_AFTER = 2500;

    /* Selecting the code is the fallback, not a nicety: it leaves the visitor
       one keystroke from copying when the clipboard is not available to us. */
    const selectText = (element) => {
      const selection = window.getSelection();
      if (!selection) return;
      const range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
    };

    const writeToClipboard = (text) => {
      if (!navigator.clipboard || !window.isSecureContext) {
        return Promise.reject(new Error('no clipboard'));
      }
      return navigator.clipboard.writeText(text);
    };

    const init = (root) => {
      const button = root.querySelector('[data-cb-offer-copy]');
      const code = root.querySelector('[data-cb-offer-code]');
      if (!button || !code) return;

      /* Only now is there a working control to show. */
      root.classList.add('cb-offer--enhanced');

      const status = root.querySelector('[data-cb-offer-status]');
      const idleLabel = button.textContent.trim();
      const copiedLabel = button.dataset.cbOfferCopiedLabel || 'Code copied';
      /* Both visitor-facing labels come from Liquid. Nothing here may hardcode
         one: a string written inside this tag is the only text on the block a
         merchant can never reach, since Liquid does not render in here. */
      const selectedLabel = button.dataset.cbOfferSelectedLabel || 'Code selected — press Ctrl or Cmd + C to copy';
      let resetTimer = null;

      const announce = (message) => {
        button.textContent = message;
        /* Cleared first so a second copy is announced as a change, not as the
           same string being written over itself. */
        if (status) {
          status.textContent = '';
          status.textContent = message;
        }
        window.clearTimeout(resetTimer);
        resetTimer = window.setTimeout(() => {
          button.textContent = idleLabel;
        }, RESET_AFTER);
      };

      button.addEventListener('click', () => {
        const text = code.textContent.trim();
        writeToClipboard(text).then(
          () => announce(copiedLabel),
          () => {
            selectText(code);
            announce(selectedLabel);
          }
        );
      });
    };

    (window.cbEnhancements = window.cbEnhancements || []).push({
      selector: ROOT_SELECTOR,
      init: init,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-promo-strip"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-cb-promo]';
    const STORAGE_PREFIX = 'cb-promo-dismissed:';

    /* Safari in private browsing throws on sessionStorage access, and a promo
       strip is not worth breaking a page over — degrade to "never remembered". */
    const readDismissed = (key) => {
      try {
        return window.sessionStorage.getItem(STORAGE_PREFIX + key) === '1';
      } catch (error) {
        return false;
      }
    };

    const rememberDismissed = (key) => {
      try {
        window.sessionStorage.setItem(STORAGE_PREFIX + key, '1');
      } catch (error) {
        /* Nothing to do: the strip still closes for this page view. */
      }
    };

    const init = (root) => {
      const button = root.querySelector('[data-cb-promo-close]');
      if (!button) return;

      const key = root.dataset.cbPromoKey;
      if (key && readDismissed(key)) {
        root.hidden = true;
        return;
      }

      /* Only now is there a working control to show. */
      root.classList.add('cb-promo--enhanced');

      button.addEventListener('click', () => {
        root.hidden = true;
        if (key) rememberDismissed(key);
      });
    };

    (window.cbEnhancements = window.cbEnhancements || []).push({
      selector: ROOT_SELECTOR,
      init: init,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-sticky-cta"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-cb-sticky-cta]';
    const BAR_SELECTOR = '[data-cb-sticky-cta-bar]';
    const ENHANCED_CLASS = 'cb-sticky-cta--enhanced';
    const REVEALED_CLASS = 'is-revealed';
    /* Both are read by the body rule in styles/sections/contentBlocks.scss. The
       class is what keeps that rule off every page WITHOUT a pinned bar. On a
       page that has one, the rule does set the body's bottom padding outright
       rather than adding to it: nothing else in the theme sets one today, and a
       reservation of the wrong size would be worse than none at all.

       --cb- here, against the --sticky-cta- of the block's own inline
       properties, because this one is published on the document — where it
       shares a namespace with --cb-anchor-offset rather than with anything
       scoped to this block. */
    const BODY_CLASS = 'cb-has-sticky-cta';
    const HEIGHT_PROPERTY = '--cb-sticky-cta-height';

    /* Read fresh every pass, so a root the theme editor has thrown away is
       simply not found rather than held alive by this snippet. */
    const pinnedRoots = () => document.querySelectorAll(ROOT_SELECTOR + '.' + ENHANCED_CLASS);

    const thresholdOf = (root) => {
      const parsed = parseFloat(root.dataset.cbStickyCtaReveal);
      return Math.min(Math.max(Number.isNaN(parsed) ? 0 : parsed, 0), 100) / 100;
    };

    /* Room at the end of the page for the bar to cover. Two bars on one page
       overlap rather than stack, so the tallest is the one to leave room for. */
    const reserve = () => {
      let tallest = 0;
      pinnedRoots().forEach((root) => {
        const bar = root.querySelector(BAR_SELECTOR);
        if (bar) tallest = Math.max(tallest, bar.getBoundingClientRect().height);
      });
      document.body.classList.toggle(BODY_CLASS, tallest > 0);
      document.documentElement.style.setProperty(HEIGHT_PROPERTY, tallest + 'px');
    };

    const update = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      /* A page too short to scroll can never pass a threshold above zero, so it
         would hide the bar forever. Nothing to scroll means nothing to wait
         for: treat it as fully scrolled. */
      const scrolled = scrollable <= 0 ? 1 : window.scrollY / scrollable;
      pinnedRoots().forEach((root) => {
        root.classList.toggle(REVEALED_CLASS, scrolled >= thresholdOf(root));
      });
    };

    /* Coalesced to one read per frame, scroll and resize alike. A listener that
       measures the document on every event is the classic way to make a page
       feel heavy, and both of these arrive in bursts — scroll for the whole
       length of a long landing page, resize for every frame of a window drag.

       `remeasure` is latched rather than passed straight through, so a resize
       that lands while a scroll frame is already queued still gets its
       measurement instead of being swallowed by it. */
    let queued = false;
    let remeasure = false;
    const schedule = (measureFirst) => {
      remeasure = remeasure || measureFirst;
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        if (remeasure) {
          remeasure = false;
          reserve();
        }
        update();
      });
    };

    window.addEventListener('scroll', () => schedule(false), { passive: true });
    /* A narrower viewport wraps the message onto a second line, so the
       reservation has to be taken again. */
    window.addEventListener('resize', () => schedule(true));

    /* Editor only. A merchant who deletes the block would otherwise keep its
       reservation as dead space at the foot of the page until a reload. */
    document.addEventListener('shopify:section:load', reserve);

    const init = (root) => {
      /* An empty block renders no bar, and pinning nothing would only strand a
         reservation for it. reserve() re-reads the bar itself. */
      if (!root.querySelector(BAR_SELECTOR)) return;

      /* Only now does the bar leave the flow. Before this it is a plain row. */
      root.classList.add(ENHANCED_CLASS);
      reserve();
      update();
    };

    (window.cbEnhancements = window.cbEnhancements || []).push({
      selector: ROOT_SELECTOR,
      init: init,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
